import React from 'react'

const PurpleBtn = ({title, onClick}) => {
  return (
    <div className='my-4 flex justify-center'>
        <button onClick={onClick} className='bg-main border border-purple rounded-[20px] transition ease-in-out duration-300 py-1 px-4 text-white hover:border-purple hover:bg-white hover:text-purple font-bold'>
          {title}
        </button>
    </div>
  )
}

export default PurpleBtn